// initial state

import api from '../api';
import { baseFields, userFragment } from '../fragments';

const state = {
  listUser: [],
};

// getters
const getters = {
  listUser: state => state.listUser,
};

// actions
const actions = {
  fetchListUser({ commit }) {
    api
      .gql({
        query: `{
          listUser {
            edges {
              node {
                ${baseFields}
                name
                type
              }
            }
          }
        }`,
        fragments: [userFragment],
      })
      .then(data => {
        const {
          listUser: { edges },
        } = data;
        const listUser = edges.map(({ node }) => node);
        commit('listUser', listUser);
      });
  },
};

// mutations
const mutations = {
  listUser(state, payload) {
    state.listUser = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
